import { IPaginationDTO, IPaginationResponse } from '@/models/pagination.model';
import { IBaseUpdateFaqDTO, IFaqBase, IFaqSearchDTO } from '@/models/faqBase.model';

export enum FaqEndpoints {
  ROOT = '/faq-channel',
}

export const staticFaqEndpoints = ({ channelId }: { channelId: number | string }) => ({
  GET_FAQS: `${FaqEndpoints.ROOT}/${channelId}`,
  CREATE_FAQ: `${FaqEndpoints.ROOT}/${channelId}`,
  DELETE_FAQS: `${FaqEndpoints.ROOT}/${channelId}`,
});

export const getFaqEndpoints = ({ channelId, faqId }: { channelId: number | string; faqId: string }) => ({
  UPDATE_FAQ: `${FaqEndpoints.ROOT}/${channelId}/${faqId}`,
});

export type IFaq = IFaqBase;

// ============== DTO ==============

export interface IGetFaqsDTO extends IPaginationDTO, IFaqSearchDTO {
  channelId: number;
}

export interface ICreateFaqDTO extends IBaseUpdateFaqDTO {
  channelId: number;
}

export interface IUpdateFaqDTO extends IBaseUpdateFaqDTO {
  faqId: string;
  channelId: number;
}

export interface IDeleteFaqsDTO {
  channelId: number;
  faqIds: string[];
}

// ============== Response ==============

export interface IGetFaqsResponse extends IPaginationResponse {
  faqs: IFaq[];
}

export type ICreateFaqResponse = IFaq;
